import * as yup from 'yup';

import { FieldPersonValue } from 'utils/serializePerson';

import { i18n } from './SelectAssistantForm.i18n';

export const schema = yup.object({
    assistant: yup.mixed<FieldPersonValue>().required(() => i18n('assistant_required')),
});
